import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";
import NotFound from "./page/not-found";
import Login from "../src/components/Auth/Login";
import SideNavLayout from "../src/components/Layout/SideNavLayout";
import ProtectedLayout from "../src/components/ProtectedLayout";
import PublicLayout from "./components/PublicLayout";
import OceanPublicLayout from "./components/OceanPublicLayout";
import AwbTrackedList from "./page/Awbtrackedlist";
import ManageContact from "./page/manage-contact";
import OceanTrackedlist from "./ocean/oceanPage/oceantrackedlist";
import AWBDashboard from "./page/Dashboard/page";
import ManageProfile from "./page/Manageprofile/Manageprofile";
import ManageCustomer from "./page/ManageCustomer/page";
import ManageOrganization from "./page/ManageOrganization/page";
import Managecredits from "./page/ManageCredits/page";
import Document_automation from "./components/DocumentAutomation/Document_automation"
import AwbTrackedListDetail from "./page/trackingDetail";
import OceanTrackedListDetail from "../src/ocean/oceanPage/oceanTrackingDetail";
import OceanCSVBulkUpload from "./ocean/oceanPage/oceancsvbulkupload";
import CSVBulkUpload from "./page/csvbulkupload";
import RoleBaseAccess from "./components/RoleBaseAccess";
import SubscriptionTemplate from "./page/Subscription-Template";
import ManageSubscription from "./page/manage-subscription";
import ForgetPassword from "./components/Auth/ForgetPassword";
import ResetPasswordPage from "./components/Auth/ResetPassword";
import AwbTrackingPage from "./page/PublicTracking/track";
import OceanTrackingPage from "./page/OceanPublicTracking/oceanTrack";
import ManageCustomerTeam from "./page/ManageCustomerTeam/page";
import ManageTags from "./page/manage-tags";
import { useRole } from "../src/components/MangeContextProvide";
import ManageCredits from "./page/manage-credit/page";
import TackingSimulatorMange from "./page/trackingSimulator/page";
import { ManageChecksAndControl } from "./page/checkandControl/page";
import MilestoneManage from "./page/milestone-management";
import GroupMilestoneMange from "./page/group-milestone-management"
import FlagManagement from "./page/manage-flags";
import CommunicationTemplete from "./page/Communication-templete";
import WebhookConfig from "./page/webhookConfig";
import CustomField from "./page/CustomField/page";
import UsageMetricsDashboard from "./page/UsageMetrics/usage-metrics-ui";
import RedirectLogin from "./components/Auth/RedirectLogin";
import ArchiveManagementPage from "./page/archieve-management";
import CommunicationErrorSLog from "./page/communication-error-log/page";
import FailedTrackingList from "./page/FailedReTry/FailedTrackinglist";
import ReportPage from "./page/reportsGenerate/Reportpage";

function App() {
  const { unreadCount,isWebhookAllowed } = useRole() as any;
  const email = localStorage.getItem("email");
  return (
    <>
      <Toaster />
      <>
        <Toaster />
        <Router>
          <Routes>
            <Route path="/" element={<Navigate to="/auth/login" />} />
            <Route path="track/:encodedawb" element={<AwbTrackingPage />} />
            <Route
              path="/auth/redirect-login"
              element={<RedirectLogin />}
            />
            <Route path="/auth" element={<PublicLayout />} />
            <Route
              path="track/ocean/:encodedocean"
              element={<OceanTrackingPage />}
            />
            <Route path="/auth" element={<OceanPublicLayout />}>
              <Route path="login" element={<Login />} />
              <Route
                path="reset-password/:resetToken"
                element={<ResetPasswordPage />}
              />
              <Route path="forgetPassword" element={<ForgetPassword />} />
            </Route>
            <Route
              path="/"
              element={
                <ProtectedLayout>
                  <SideNavLayout unreadCount={unreadCount} />
                </ProtectedLayout>
              }
            >
              <Route
                path="tracking-management"
                element={
                  <RoleBaseAccess>
                    <AWBDashboard />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="manage-profile"
                element={
                  <RoleBaseAccess>
                    <ManageProfile />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="manage-users"
                element={
                  <RoleBaseAccess>
                    <ManageCustomer />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="add-organization"
                element={
                  <RoleBaseAccess>
                    <ManageOrganization />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="manage-credits"
                element={
                  <RoleBaseAccess>
                    <Managecredits />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="manage-teams"
                element={
                  <RoleBaseAccess>
                    <ManageCustomerTeam />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="awbtrackedlist"
                element={
                  <RoleBaseAccess>
                    <AwbTrackedList />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="oceantrackedlist"
                element={
                  <RoleBaseAccess>
                    <OceanTrackedlist />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="trackingDetail"
                element={
                  <RoleBaseAccess>
                    <AwbTrackedListDetail />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="oceancsvbulkupload"
                element={
                  <RoleBaseAccess>
                    {" "}
                    <OceanCSVBulkUpload />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="csvbulkupload"
                element={
                  <RoleBaseAccess>
                    <CSVBulkUpload />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="trackingDetail"
                element={
                  <RoleBaseAccess>
                    <AwbTrackedListDetail />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="oceanTrackingDetail"
                element={
                  <RoleBaseAccess>
                    <OceanTrackedListDetail />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="csvbulkupload"
                element={
                  <RoleBaseAccess>
                    <CSVBulkUpload />{" "}
                  </RoleBaseAccess>
                }
              />
              <Route
                path="manage-contact"
                element={
                  <RoleBaseAccess>
                    <ManageContact />{" "}
                  </RoleBaseAccess>
                }
              />

              <Route
                path="manage-tags"
                element={
                  <RoleBaseAccess>
                    <ManageTags />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="manage-flags"
                element={
                  <RoleBaseAccess>
                    <FlagManagement />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="communication-template"
                element={
                  <RoleBaseAccess>
                    <CommunicationTemplete />{" "}
                  </RoleBaseAccess>
                }
              />
              <Route
                path="manage-profile"
                element={
                  <RoleBaseAccess>
                    <ManageProfile />{" "}
                  </RoleBaseAccess>
                }
              />
              <Route
                path="subscription-template"
                element={
                  <RoleBaseAccess>
                    <SubscriptionTemplate />{" "}
                  </RoleBaseAccess>
                }
              />
              <Route
                path="communication-template"
                element={
                  <RoleBaseAccess>
                    <CommunicationTemplete />{" "}
                  </RoleBaseAccess>
                }
              />
              <Route
                path="manage-communication"
                element={
                  <RoleBaseAccess>
                    <ManageSubscription />{" "}
                  </RoleBaseAccess>
                }
              />
            </Route>
            <Route
              path="/"
              element={
                <ProtectedLayout>
                  <SideNavLayout unreadCount={unreadCount} />
                </ProtectedLayout>
                
              }
            >

              <Route
                path="credit-management"
                element={
                  <RoleBaseAccess>
                    <ManageCredits />
                  </RoleBaseAccess>
                }
              />
              {email === "kashish.sharma@skyways-group.com" && (<Route
                path="document_automation"
                element={
                  <RoleBaseAccess>
                    <Document_automation />{" "}
                  </RoleBaseAccess>
                }
              />)}
              {email === "kashish.sharma@skyways-group.com" && (<Route
                path="tracking-simulator"
                element={
                  <RoleBaseAccess>
                    <TackingSimulatorMange />
                  </RoleBaseAccess>
                }
              />)}
              {/* <Route
                path="archive-management"
                element={
                  <RoleBaseAccess>
                    <ManageChecksAndControl />
                  </RoleBaseAccess>
                }
              /> */}
              <Route
                path="milestone-management"
                element={
                  <RoleBaseAccess>
                    <MilestoneManage />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="manage-milestone-grouping"
                element={
                  <RoleBaseAccess>
                    <GroupMilestoneMange />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="manage-flags"
                element={
                  <RoleBaseAccess>
                    <FlagManagement />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="manage-custom-fields"
                element={
                  <RoleBaseAccess>
                    <CustomField />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="usage-metrics"
                element={
                  <RoleBaseAccess>
                    <UsageMetricsDashboard />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="milestone-webhooks"
                element={
                  <RoleBaseAccess>
                    <WebhookConfig />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="archive-management"
                element={
                  <RoleBaseAccess>
                    <ArchiveManagementPage />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="communication-errors"
                element={
                  <RoleBaseAccess>
                    <CommunicationErrorSLog />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="failed-tracking"
                element={
                  <RoleBaseAccess>
                    <FailedTrackingList />
                  </RoleBaseAccess>
                }
              />
              <Route
                path="report"
                element={
                  <RoleBaseAccess>
                    <ReportPage/>
                  </RoleBaseAccess>
                }
              />
            </Route>


            <Route path="/*" element={<NotFound />} />
          </Routes>
        </Router>
      </>
    </>
  );
}
export default App;